import React, { useEffect, useState } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { useNavigate } from "react-router-dom";

const Profiles = () => {
  const isLoggedIn = localStorage.getItem("token");
  const nav = useNavigate();

  const [profiles, setProfiles] = useState([]);
  const [filteredProfiles, setFilteredProfiles] = useState([]);
  const [filters, setFilters] = useState({
    minAge: "",
    maxAge: "",
    gender: "",
    religion: "",
    caste: "",
    location: "",
    education: "",
  });

  useEffect(() => {
    const fetchProfiles = async () => {
      try {
        const response = await fetch('https://shubhjiwan.co.in/ShubhJiwan_backend11/fetch_profiles.php');
  
        console.log(`HTTP Status: ${response.status}`);
        
        if (!response.ok) {
          console.error("❌ Network error: Unable to fetch data.");
          return;
        }
  
        let json = await response.json();
        console.log("Raw response text:", json);
  
        // let json;
        try {
          // json = JSON.parse(text);
        } catch (error) {
          console.error("❌ Error parsing JSON:", error);
          return;
        }
  
        if (json.error) {
          console.error("❌ Server error:", json.error);
          return;
        }
  
        if (json.profiles) {
          setProfiles(json.profiles);
        } else {
          console.error("❌ No 'profiles' field in response");
        }
      } catch (error) {
        console.error("❌ Error fetching profiles:", error);
      }
    };
  
    fetchProfiles();
  }, []);
  
  
  
  

  useEffect(() => {
    setFilteredProfiles(profiles);
  }, [profiles]);

  if (!isLoggedIn) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="bg-white p-8 rounded-lg shadow-lg max-w-md w-full text-center">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800">Access Denied</h2>
          <p className="text-red-500 font-medium mb-4">Please log in to view full details!</p>
          <button
            onClick={() => nav("/login")}
            className="bg-red-500 text-white px-6 py-2 rounded shadow hover:bg-red-600 transition"
          >
            Log In
          </button>
        </div>
      </div>
    );
  }

  const applyFilters = () => {
    let filtered = [...profiles];

    // Apply age filters
    if (filters.minAge) {
      filtered = filtered.filter(profile => profile.age >= parseInt(filters.minAge));
    }
    if (filters.maxAge) {
      filtered = filtered.filter(profile => profile.age <= parseInt(filters.maxAge));
    }

    // Apply other filters
const filterConditions = [
  { key: 'religion', value: filters.religion },
  { key: 'caste', value: filters.caste },
  { key: 'location', value: filters.location },
  { key: 'education', value: filters.education },
];

if (filters.gender) {
  filtered = filtered.filter(profile => (profile.gender || "").toLowerCase() === filters.gender.toLowerCase());
}

    filterConditions.forEach(({ key, value }) => {
      if (value) {
        filtered = filtered.filter(profile => (profile[key] || "").toLowerCase().includes(value.toLowerCase()));
      }
    });

    setFilteredProfiles(filtered);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({ ...prev, [name]: value }));
  };

  const resetFilters = () => {
    setFilters({
      minAge: "",
      maxAge: "",
      gender: "",
      religion: "",
      caste: "",
      location: "",
      education: "",
    });
    setFilteredProfiles(profiles);
  };

  return (
    <>
      <div
      style={{
        background: "linear-gradient(to right, #E5DCFA 0%, #D3C5F8 100%)",
      }}
    >
      <div className="absolute w-full">
        <Navbar />
        <div className="bg-gray-50 min-h-screen w-[100%] mt-10">
          <div className="max-w-[1140px] container mx-auto px-4 py-8">
            <div className="grid grid-cols-12 gap-8">
              {/* Sidebar Filters */}
              <aside className="col-span-12 lg:col-span-3 bg-white shadow-md p-6 lg:sticky lg:top-16 lg:h-screen">
                <h3 className="text-xl font-bold mb-4">Filters</h3>

                {/* Age Filters */}
                <div className="mb-4">
                  <label className="block font-medium mb-1">Age Between</label>
                  <div className="flex gap-2">
                    <input
                      type="number"
                      name="minAge"
                      placeholder="Min Age"
                      value={filters.minAge}
                      onChange={handleInputChange}
                      className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
                    />
                    <input
                      type="number"
                      name="maxAge"
                      placeholder="Max Age"
                      value={filters.maxAge}
                      onChange={handleInputChange}
                      className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
                    />
                  </div>
                </div>

                {/* Gender Filter */}
                <div className="mb-4">
                  <label className="block font-medium mb-1">Gender</label>
                  <select
                    name="gender"
                    value={filters.gender}
                    onChange={handleInputChange}
                    className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
                  >
                    <option value="">Select Gender</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                  </select>
                </div>

                {/* Religion Filter */}
                <div className="mb-4">
                  <label className="block font-medium mb-1">Religion</label>
                  <select
                    name="religion"
                    value={filters.religion}
                    onChange={handleInputChange}
                    className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
                  >
                    <option value="">Select Religion</option>
                    <option value="Hindu">Hindu</option>
                    <option value="Muslim">Muslim</option>
                    <option value="Christian">Christian</option>
                    <option value="Sikh">Sikh</option>
                  </select>
                </div>

                {/* Caste Filter */}
                <div className="mb-4">
                  <label className="block font-medium mb-1">Caste</label>
                  <input
                    type="text"
                    name="caste"
                    placeholder="e.g., Maratha"
                    value={filters.caste}
                    onChange={handleInputChange}
                    className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
                  />
                </div>

                {/* Location Filter */}
                <div className="mb-4">
                  <label className="block font-medium mb-1">Location</label>
                  <input
                    type="text"
                    name="location"
                    placeholder="e.g., Pune, Maharashtra"
                    value={filters.location}
                    onChange={handleInputChange}
                    className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
                  />
                </div>

                {/* Education Filter */}
                <div className="mb-4">
                  <label className="block font-medium mb-1">Education</label>
                  <input
                    type="text"
                    name="education"
                    placeholder="e.g., Graduate"
                    value={filters.education}
                    onChange={handleInputChange}
                    className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
                  />
                </div>

                <button
                  onClick={applyFilters}
                  className="w-full bg-[#EC018B] text-white py-2 rounded transition"
                >
                  Apply Filters
                </button>
                <button
                  onClick={resetFilters}
                  className="w-full bg-[#027CC5] text-white py-2 rounded mt-2 transition"
                >
                  Reset Filters
                </button>
              </aside>

              {/* Main Content */}
              <main className="col-span-12 lg:col-span-9">
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 overflow-hidden">
                  {filteredProfiles.map((profile) => (
                    <div
                      key={profile.id}
                      className="bg-white shadow-md rounded-lg overflow-hidden duration-300"
                    >
                      <img
                        src={profile.image}
                        alt={profile.fullName}
                        className="w-full lg:h-80 h-96 object-cover"
                      />
                      <div className="p-4">
                        <h4 className="font-bold text-lg">{profile.fullName}</h4>
                        <p className="text-sm text-gray-600">
                          {profile.age} years, {profile.location}
                        </p>
                        <p className="text-sm text-gray-500">{profile.profession}</p>
                        <button
                          className="bg-[#EC018B] text-white rounded-md my-2 p-2"
                          onClick={() => nav(`/profileDetails/${profile.id}`)}
                        >
                          View Profile
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </main>
            </div>
          </div>
        </div>
        <Footer />
      </div>
      </div>
    </>
  );
};

export default Profiles;
